export default {
  LandingPage: {
    intro_sub:
      'Подаруйте друге життя упаковці та захистіть навколишнє середовище.',
    title: 'Samsung Upcycle-Packaging',
    sequence1_1:
      'Приєднуйтеся до нас, щоб зменшити кількість сміття і допомогти довкіллю',
    sequence1_2:
      'перетворивши продукту упаковку на корисні речі. Проскрольте вниз, щоб зробити перший крок',
    sequence2_1: 'Представляємо Upcycle-Packaging від Samsung',
    sequence2_2:
      'Продукту коробка  спеціально розроблена для повторного використання. Створіть різні предмети для дому за допомогою продукту упаковки',
    sequence3_1:
      'За допомогою надрукованих на коробці крапок розріжте упаковку',
    sequence3_2:
      'Потім зберіть вирізане за інструкцією, щоб створити неймовірний предмет для побуту',
    sequence4_1: 'Оберіть предмет, який ви хочете створити',
    sequence4_2:
      'Проскрольте вниз і оберіть продукту, від якого у вас є упаковка. Після цього знайдіть різні варіанти дизайну. І, нарешті, почніть створювати бажаний предмет',
    selectBox: 'Виберіть Ваш продукту',
    moreActivity:
      'для отримання додаткової інформації про сталу діяльність Samsung',
    OLED: 'OLED',
    QLED8K: 'QLED', //update
    UHD: 'UHD', //update
    FHD: 'FHD',
    HD: 'HD',
    theFrame: 'The Frame',
    theSerif: 'The Serif',
    theSero: 'The Sero',
    theTerrace: 'The Terrace', //update
    thePremiere: 'The Premiere', //update
    Monitors: 'Monitors', //update
    OdysseyArk:"Odyssey Ark",
    QSoundbar: 'Q Soundbar', //update
    Soundbar: 'Soundbar', //update
    SoundbarSet01:'Soundbar Set 1',
    SoundbarSet02:'Soundbar Set 2',
    TheTerraceSoundbar:'The Terrace Soundbar',
    Soundtower:'Sound Tower',
    BespokeJet: 'BESPOKE Jet\n (Jet)',
    BespokeJetStation:'BESPOKE Jet\n (Clean Station™)',
    BespokeJetNCleanStation : 'BESPOKE Jet&\nClean Station™',
    BespokeJetNCleanStation2 : 'BESPOKE Jet&Clean Station™',
    BespokeCube53:'BESPOKE Cube™ AIR\n(53㎡)',
    BespokeCube70:'BESPOKE Cube™ AIR\n(70㎡)',
    BespokeCube106:'BESPOKE Cube™ AIR\n(106㎡)',
    BespokeCube123:'BESPOKE Cube™ AIR\n(123㎡)',
    Qooker:'Qooker',
    BespokeSlim:'BESPOKE \nSlim',
    TheFreeStyle:"The Freestyle",
    BespokeSlimCleanStation:"BESPOKE Slim&Jet\n(Clean Station™)",
    JetCleanStation:"Jet&\nClean Station™",
    JetCleanStation2:"Jet&Clean Station™",
    BlueSky:"BlueSky \n5500",
    BlueSky3000:"BlueSky \n3000",
    BlueSky3100:"BlueSky \n3100",
    BlueSky5000:"BlueSky \n5000",
    BespokeJetbot:"BESPOKE\n Jet Bot",
    BespokeJetbot2:"BESPOKE Jet Bot",
    BespokeJetbotPlus:"BESPOKE\n Jet Bot+",
    BespokeJetbotPlus2:"BESPOKE Jet Bot+",
    BespokeJetbotAI:"BESPOKE\n Jet Bot AI",
    BespokeJetbotAI2:"BESPOKE Jet Bot AI",
    Canister01:"Canister \n01",
    Canister02:"Canister \n02",
    Jupiter:"Vacuum \nCleaner",
    ref_cube:"BESPOKE Cube",
    WaterPurifier:"Water Purifier",
    LATIN:"LATIN",
    LATIN10:"LATIN10",
    MIRROR:"MIRROR",
    MW5100J:"MW5100J",
    STENA:"STENA",
    // moreActivityLink:
    //   'https://www.samsung.com/ua/sustainability/overview/',
    // moreActivityLink:'https://www.samsung.com/ua/aboutsamsung/sustainability/strategy/',
    moreActivityLink: 'https://www.samsung.com/ua/sustainability/overview/',
    footer: 'Copyright © 2019-2021 SAMSUNG. Всі права захищено.',
    // <br/>
    // Цей сайт рекомендується переглядати у браузері Internet Explorer 11 або в пізніших версіях Internet Explorer, та/або в останніх версіях браузерів Google Chrome та Mozilla Firefox.
  },
  ProductPage: {
    selectDesign: 'Виберіть дизайн для створення',
    selectDesignDezeen: 'Samsung X Dezeen', //update
    selectDesignSoccer: 'Samsung X Football', 
    tvConsole: 'Консоль телевізора',
    StorageBox: 'Коробка для зберігання',
    MagazineRack: 'Стелаж для журналів',
    CatHouse: 'Будинок для кота',
    CatTunnel: 'Котячий тунель',
    BookShelf: 'Полиця для книг',
    DeskShelf: 'Настільна полиця',
    BlackRhino: 'Endangered \n Animals \n Black Rhino', //update
    PolarBear: 'Endangered \n Animals \n Polar Bear', //update
    SeaTurtle: 'Endangered \n Animals \n Sea Turtle', //update
    TheRider: 'The Rider', //update
    Kibe: 'Kibe', //update
    Tessellate: 'Tessellate', //update
    Twist: 'Twist', //update
    AlexCouchArmTable: 'Alex Couch \n Arm Table', //update
    BlastOffClubHouse: 'Blast Off \n Club House', //update
    KinokoTable: 'Kinoko table', //update
    Magnuss: 'Magnuss', //update
    GIO: 'Gio', //update
    PostCardPlanter: 'Postcard \n Planter', //update
    SneakerRack: 'Sneaker \n Rack', //update
    TheSoban: 'The Soban', //update
    ToolBox: 'Tool Box', //update
    DeskStationary: 'Stationery',
    // DeskStationary: 'Ящик для канцелярського приладдя',
    CoinBank: 'Cкарбничка',
    MobileScanner:'Підставка для сканера смартфона',
    TabletScanner:'Підставка для планшетного сканера',
    PetStairs:'Домашні сходи',
    PetFurniture: 'Pet Friendly Furniture',
    ShoeRackA:'Shoe Rack_A',
    ShoeRackB:'Shoe Rack_B',
    WineRackDog:'Wine Rack Dog',
    WineRack:'Wine Rack',
    mins: 'хв',
    all:'ALL',
    in: 'дюйм',
    inOnly: 'лише',
    allBoxSize: 'Усі розміри коробки',
    soccergoalpost:'Mini Soccer Goal Post',
   soccerboard:'Table Soccer Board',
   sixpackcarrier:'Six Pack Carrier',
   trophytable:'Trophy Cup Table',
   megaphone:'Cheer Megaphone',
   FreestyleBear:'Small \n Animals \n Polar Bear',
   FreestyleRay:'Small \n Animals \n Ray',
   FreestyleRhino:'Small \n Animals \n Black Rhino',
   FreestyleSeahorse:'Small \n Animals \n See Horse',
   FreestyleWhale:'Small \n Animals \n Whale',
   Mickey:'Mickey Mouse',
   Pluto:'Pluto',
   Diseny:'Samsung X Disney'
  },
  DetailGuidePage: {
    1:'1',
    2:'2',
    3:'3',
    instructions: 'інструкції',
    prepare: 'Підготуйте коробку',
    LetsDesign: 'Давайте конструювати',
    drawParts: 'Намалюйте деталі на коробці',
    note1:
      'Зауважте, що графічне положення може відрізнятися залежно від країн та розмірів',
    note2: 'Спочатку накресліть весь малюнок, щоб він відповідав коробці',
    numberSpace: 'число = проміжки між точками',
    diagonal: 'діагональ',
    LEFT: 'ЛІВО',
    RIGHT: 'ПРАВО',
    TOP: 'ЗВЕРХУ',
    TOP1: 'ЗВЕРХУ 1',
    TOP2: 'ЗВЕРХУ 2',
    BACK: 'ЗЗАДУ',
    MIDDLE: 'ПО СЕРЕДИНІ',
    MIDDLE2: 'ПО СЕРЕДИНІ 2',
    BOTTOM: 'ЗНИЗУ',
    FRONT: 'ЗПЕРЕДУ',
    SIDE: 'СТОРОНА',
    secondSIDE: 'ДРУГА СТОРОНА',
    secondSIDE1: 'ДРУГА СТОРОНА 1',
    secondSIDE2: 'ДРУГА СТОРОНА 2',
    LEG: 'МІСТ', //update
    JOINT: `З'ЄДНАННЯ`, //update
    FACE: 'ТИЛЬНА СТОРОНА', //update
    DRAWERBOTTOM: 'ДНО ЯЩИКА', //update
    DRAWERSIDE: 'БОКОВА СТОРОНА ЯЩИКА', //update
    NOSE: 'НОСОВА ЧАСТИНА', //update
    HANDLE: 'РУЧКА', //update
    BOTTOMSIDE: 'НИЖНЯ СТОРОНА', //update
    TOPSIDE: 'ВЕРХНЯ СТОРОНА', //update
    WING: 'КРИЛО', //update
    cutAndAssemble: 'Давайте виріжемо і зберемо',
    beCareful: 'Будьте обережні, щоб не нашкодити собі при використанні різака',
    cutOutParts: 'Виріжте частини',
    assemble: 'Зберіть',
    Assemblyguide: 'Керівництво по збірці', //update
    fold: 'Приклад складання',
    foldGuide: 'Використовуйте край меблів, складаючи картон',
    foldGuideDezeen:
      'Використовуючи інструмент для складання паперу, декілька разів натисніть на пунктирну лінію щоб скласти картон', //update
    glue: `Рівномірно нанесіть клей або скотч на поверхню`, //update
    cable: `З'єднайте за допомогою кабельних стяжок або мотузок`, //update
    done: 'Готово!',
    goBack: 'Поверніться до головного меню',
  },
  CautionPage: {
    CAUTION: 'УВАГА',
    needItem: 'Вам знадобляться ці предмети',
    children: 'Діти повинні бути під наглядом дорослих',
    mat:
      'Будь ласка, покладіть будь-яке покриття на землю, щоб уникнути подряпин впродовж процесу',
    doNotPutHeavyThing:
      'Не наступайте та не сідайте на ці конструкції, а також не намагайтеся покласти на них важкі речі',
    doNotThrow:
      'Не кидайте та не ударяйте ці конструкції о що-небудь, включаючи людей та тварин',
    stayAwayFlame: 'Тримайте подалі від полум’я',
    stayAwayWater: 'Не наближайтесь до води чи уникайте вологості',
    mayDamaged:
      '* Під час доставки коробка від телевізора може бути пошкоджена',
    companyDoestResponsible:
      '* Компанія не несе відповідальності за поломки або травми під час цієї роботи',
    cannotBeReturned:'',
    understand: 'Гаразд, я зрозумів',
  },
  PrivacyPolicy: {
    title: 'Політика конфіденційності',
  },
  GoingGreen: {
    visual: {
      title: 'Going Green',
      text1:
        'Ми підтримуємо свою прихильність до сталого розвитку завдяки новому екологічно чистому пакуванню.',
      text2:
        'Нове пакування для телевізора містить менше паперу та чорнила, яке може буди предметом побуту після використання.',
      text2_special:'',
      text3: 'Будь ласка, натисніть кнопку нижче, щоб дізнатись більше.',
    },
    greenIn: {
      title:
        'Переходьте до захисту навколишнього середовища з пакуванням від телевізора',
      subtitle1: 'Інформація про товар, що не містить чорнила',
      subtitle2: 'Еко-пакування з можливістю повторного використання',
      desc:
        'Для отримання більш детальної інформації, шукайте за назвою моделі',
      descM: '*Take a photo of the TV model number',
      guide: 'назва моделі',
      button: 'Take Photo',
      button2: 'Перейдіть до вибору пунктів',
    },
    search: {
      guide: 'Search..',
      noResult: 'Результату немає',
      more: 'Дізнатися більше',
    },
  },
  searchCountrySelect: 'Виберіть країну для пошуку'
};
